import { FC } from 'react'

import { ISvgClass } from '../interface'

const DocumentPlusIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path d="M841 4944 c-169 -45 -301 -180 -346 -351 -23 -86 -23 -3980 0 -4066 46 -178 193 -320 367 -356 36 -8 273 -11 744 -9 l691 3 37 29 c90 68 86 190 -8 260 -27 21 -40 21 -726 26 -686 5 -699 5 -726 26 -15 11 -37 33 -48 48 l-21 27 0 1979 0 1979 21 27 c11 15 33 37 48 48 27 21 35 21 1044 24 759 2 1025 -1 1047 -9 39 -16 671 -643 696 -691 18 -35 19 -63 19 -523 0 -539 -1 -530 66 -581 31 -24 47 -29 94 -29 47 0 63 5 94 29 67 51 66 40 65 593 0 556 -2 576 -69 686 -22 37 -154 177 -389 411 -319 318 -363 358 -421 385 -36 17 -89 35 -119 41 -34 6 -421 10 -1080 9 -863 0 -1035 -3 -1080 -15z" />
        <path d="M3220 2714 c-208 -27 -407 -101 -580 -217 -96 -64 -273 -241 -337 -337 -95 -142 -163 -302 -199 -470 -26 -119 -26 -381 0 -500 56 -259 167 -463 355 -651 188 -188 392 -299 651 -355 119 -26 381 -26 500 0 259 56 463 167 651 355 188 188 299 392 355 651 26 119 26 381 0 500 -56 262 -167 463 -360 656 -183 182 -374 288 -626 345 -83 19 -331 33 -410 23z m371 -343 c179 -46 319 -127 449 -260 129 -130 212 -278 257 -457 24 -95 24 -333 0 -428 -46 -182 -128 -328 -261 -462 -134 -133 -280 -215 -462 -261 -95 -24 -333 -24 -428 0 -182 46 -328 128 -462 261 -133 134 -215 280 -261 462 -24 95 -24 333 0 428 95 380 389 659 770 732 100 19 299 12 398 -15z" />
        <path d="M3295 2066 c-37 -17 -70 -52 -84 -89 -6 -16 -11 -103 -11 -202 l0 -174 -189 -3 c-173 -3 -192 -5 -217 -24 -44 -32 -66 -68 -71 -116 -7 -58 15 -108 63 -144 l37 -29 189 -3 188 -3 0 -175 c0 -199 6 -225 66 -270 31 -24 47 -29 94 -29 47 0 63 5 94 29 60 45 66 71 66 270 l0 175 188 3 189 3 37 29 c90 68 86 190 -8 260 -25 19 -44 21 -216 24 l-189 3 -3 189 c-3 206 -6 215 -70 263 -34 25 -113 32 -153 13z" />
      </g>
    </svg>
  )
}

export default DocumentPlusIcon
